module.exports = __webpack_public_path__ + "static/media/neosoft.5672658b.png";